import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '@common/utils/utils';

@Pipe({
  name: 'domain'
})
export class DomainPipe implements PipeTransform {
  transform(value: string): string {
    return Utils.domainFormat(value);
  }
}
